import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import { debounce } from 'lodash'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import InputAdornment from '@material-ui/core/InputAdornment'
import FormControl from '@material-ui/core/FormControl'
import FilterListIcon from '@material-ui/icons/FilterList'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'

class SessionListFilter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filter: ''
    }
  }

  componentDidMount() {
    this.handleDebounceChange = debounce(() => {
      this.props.onChange(this.state.filter)
    }, 250)
  }

  handleChange = filter => {
    this.setState({ filter: filter }, () => {
      this.handleDebounceChange()
    })
  }


  render() {
    const { className, t } = this.props
    const { filter } = this.state
    const { handleChange } = this

    return (
      <FormControl className={className}>
        <InputLabel htmlFor="session-filter">Filter</InputLabel>
        <Input
          id="session-filter"
          placeholder={t('Filter')}
          value={filter}
          onChange={e => handleChange(e.target.value)}
          endAdornment={!filter.length ? (
            <InputAdornment>
              <FilterListIcon />
            </InputAdornment>
          ) : (
            <InputAdornment>
              <IconButton
                aria-label={t('Clear')}
                onClick={() => handleChange('')}
              ><CloseIcon /></IconButton>
            </InputAdornment>
          )
          }
        />
      </FormControl>
    )
  }
}

SessionListFilter.defaultProps = {
  onChange: null,
  className: ''
}

SessionListFilter.propTypes = {
  onChange: PropTypes.func,
  className: PropTypes.string,
  t: PropTypes.func
}

export default translate()(SessionListFilter)



// WEBPACK FOOTER //
// ./src/components/setup/recall-session/by-decision/SessionList/SessionListFilter.js